import { Injectable } from '@angular/core';
import { GqlParser, QueryResult } from '@unipin/angular-gql';
import { Observable } from 'rxjs';
import { CmsPostTermFilter, CmsPostTermResult } from 'graphql/generated';
import { CountryService } from './country.service';

@Injectable({ 
  providedIn: 'root' 
})
export class PostTermService {

  constructor(
    protected readonly gql: GqlParser,
    protected readonly countryService: CountryService
  ) { }

  public query(filter: CmsPostTermFilter, isHome: boolean = false, extraAttr: string = ''): Observable<QueryResult<{ cmsMsPostTerms: CmsPostTermResult }>>{
    filter.countryCode = this.countryService.activeCountry().code;
    
    return this.gql.query({
      operationName: 'QueryPostTerm',
      variables: { 
        isHome,
        filter,
      },
      query: `
        query QueryPostTerm($filter: CmsPostTermFilter!, $isHome: Boolean!) {
          cmsMsPostTerms(filter: $filter, isHome: $isHome) {
            data {
              guid 
              termName 
              termType 
              urlKey
              ${ extraAttr }
            }
          }
        }
      `
    });
  }
}
